var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('form-field',{attrs:{"field":_vm.content}}),(_vm.hasAttachments)?_c('div',[_c('div',{staticClass:"divider mt-4 mb-4"}),_c('attachment-list',{staticClass:"ml-2",attrs:{"messageIndex":_vm.index}})],1):_vm._e(),_c('respond-actions',{staticClass:"ml-5 mt-8",attrs:{"index":_vm.index}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }